// Сигналите на склада — значки и точки по тежест. Чисти константи (без
// компоненти), за да се ползват и от менюто, и от таблото, и от моделите.
// Йерархията на модула (docs/inventory.md §Плътност и сигнали). Кехлибарът е
// бранд и избор, НЕ тревога:
//  • critical — червено: незавършена инвентаризация, отчет неразнесен над 2
//    дни, задържана доставка, неплатена над 14 дни. Бял текст на bg-danger
//    (4.8:1); винаги с текст и действие, не само цвят;
//  • attention — меко кехлибарено (тъмен текст на brand-tint, ≥4.5:1): днешните
//    чакащи отчети, неплатените, излишъкът;
//  • info — синьо: факт, не задача;
//  • neutral — брояч (днешните чернови).
export type SignalTone = "critical" | "attention" | "info" | "neutral";

export const SIGNAL_BADGE_CLASS: Record<SignalTone, string> = {
  critical: "bg-danger text-white",
  attention: "border border-brand-tint2 bg-brand-tint text-brand-deep-ink",
  info: "bg-info-tint text-info-deep",
  neutral: "bg-fill-3 text-ink-2",
};

export const SIGNAL_DOT_CLASS: Record<SignalTone, string> = {
  critical: "bg-danger",
  attention: "bg-brand",
  info: "bg-info",
  neutral: "bg-faint",
};

const SIGNAL_RANK: Record<SignalTone, number> = { neutral: 1, info: 2, attention: 3, critical: 4 };

// Най-силният тон от няколко (празно/само null → null)
export const strongestSignal = (tones: (SignalTone | null | undefined)[]): SignalTone | null =>
  tones.reduce<SignalTone | null>(
    (best, tone) => (tone && (!best || SIGNAL_RANK[tone] > SIGNAL_RANK[best]) ? tone : best),
    null,
  );

